import { createStyles, makeStyles } from '@material-ui/styles';
import AutumnLeaf from '../../../../assets/seasons/ChallengeButton/autumnleaf.webp';
import SpringLeaf from '../../../../assets/seasons/ChallengeButton/springleaf.webp';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      borderRadius: palette.borderRadius.default,
      transition: '0.2s ease',
      color: palette.text.white,
      fontWeight: 700,
      fontSize: '1rem',
      height: '44px',
      paddingLeft: '10px',
      paddingRight: '10px',
      boxShadow: palette.shadows.buttonShadow,
      textShadow: palette.shadows.textShadow,
      border: 'none',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 100%, cover',
      '@media (max-width: 425px)': {
        fontSize: '0.8rem'
      },
      '@media (max-width: 724px)': {
        width: '-webkit-fill-available',
        '&:active': {
          transform: 'scale(1.2)'
        }
      },
      '@media (min-width: 725px)': {
        transition: '0.3s ease',
        '&:hover': {
          transform: 'scale(1.1)',
          backgroundSize: '140% 140%, cover'
        }
      },
      cursor: 'pointer'
    },
    default: {
      background: palette.text.primary
    },
    autumn: {
      backgroundImage: `url(${AutumnLeaf})`,
      backgroundColor: palette.background.autumn
    },
    spring: {
      backgroundImage: `url(${SpringLeaf})`,
      backgroundColor: palette.background.spring
    },
    noLeftRadius: {
      borderRadius: '0px 10px 10px 0px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
